import React, { HTMLAttributes } from 'react';

import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import {
  BackgroundIcon,
  Button,
  Container,
  ContainerInfo,
  ContainerPrice,
  ContainerTitle,
  CurrentTag,
  Info,
  Price,
  Title,
} from './styles';

interface cardProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  news: number | null;
  exercises: number | null;
  users: number | null;
  price: number;
  currentSubscription?: boolean;
  disabled?: boolean;
  disabledLabel?: string;
  functionButton?: any;
}

const planIcon = (title: string): string => {
  const normalized = title.toLowerCase();

  if (normalized.includes('pro')) return 'workspace_premium';
  if (normalized.includes('standard')) return 'monitoring';

  return 'fitness_center';
};

const capLabel = (value: number | null): string =>
  value === null ? 'Ilimitado' : String(value);

const CardSubscription: React.FC<cardProps> = ({
  title,
  news,
  exercises,
  users,
  price,
  currentSubscription = false,
  disabled = false,
  disabledLabel = 'Indisponível',
  functionButton,
  ...rest
}) => {
  return (
    <Container currentSubscription={currentSubscription} {...rest}>
      {currentSubscription && <CurrentTag>Plano atual</CurrentTag>}

      <BackgroundIcon>
        <Icon name={planIcon(title)} size={96} color={colors.onSurface} />
      </BackgroundIcon>

      <ContainerTitle>
        <Title>{title}</Title>
      </ContainerTitle>

      <ContainerInfo>
        <Info>
          <div>
            <Icon name="warning" size={20} color={colors.onSurfaceVariant} />
            <span>Alertas: </span>
          </div>
          <span>{capLabel(news)}</span>
        </Info>
        <Info>
          <div>
            <Icon
              name="fitness_center"
              size={20}
              color={colors.onSurfaceVariant}
            />
            <span>Exercícios: </span>
          </div>
          <span>{capLabel(exercises)}</span>
        </Info>
        <Info>
          <div>
            <Icon name="group" size={20} color={colors.onSurfaceVariant} />
            <span>Usuários: </span>
          </div>
          <span>{capLabel(users)}</span>
        </Info>
      </ContainerInfo>

      <ContainerPrice>
        <Price>
          <span>R$</span>
          <span className="price">{price.toFixed(2)}</span>
          <span>/mês</span>
        </Price>
        <Button
          name="contract"
          value={disabled ? disabledLabel : 'Contratar'}
          disabled={disabled}
          onClick={functionButton}
        />
      </ContainerPrice>
    </Container>
  );
};

export { CardSubscription };
